/***
 * @file:ç¶æè²åè½¬æ¢ç®¡é
 * @author: linkun.he
 * @Date: 2019-06-05 14:07:23
 */
import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash';
import { Colorlump } from './colorLump.interface';

@Pipe({
  name: 'colorLump',
})
export class ColorLumpPipe implements PipeTransform {
  transform(value: string, config: Colorlump[]): any {
    const lumpData = config.filter((conf) => conf.name === value);
    if (!isEmpty(lumpData)) {
      return creatLump(lumpData[0]);
    } else {
      return '';
    }
  }
}

function creatLump(conf: Colorlump) {
  return `<span class="color-lump" style="background: #fff; color:${conf.color}; border: 1px  ${conf.color} solid;border-radius: 14px;">${conf.name}<span>`;
}
